import React, { useMemo, useState } from 'react'
import { httpsCallable } from 'firebase/functions'
import { getAuth } from 'firebase/auth'
import { functions } from '../firebase-config'
import { sanitizeDni } from '../utils/authHelper'

export default function TicketCreator({ dictamenId, versionNormativa }) {
  const [asunto, setAsunto] = useState('')
  const [detalle, setDetalle] = useState('')
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState('')
  const [error, setError] = useState('')

  const userId = useMemo(() => {
    const user = getAuth().currentUser
    if (!user || !user.email) return ''
    return sanitizeDni(user.email.split('@')[0] || '')
  }, [])

  const handleCreate = async () => {
    setMsg('')
    setError('')
    if (!dictamenId) {
      setError('No se detecto dictamen asociado para abrir ticket.')
      return
    }
    if (asunto.trim().length < 8) {
      setError('El asunto debe tener al menos 8 caracteres.')
      return
    }

    setLoading(true)
    try {
      const callCreate = httpsCallable(functions, 'createSupportTicket')
      const resp = await callCreate({
        dictamenId,
        versionNormativa: versionNormativa || 'desconocida',
        userId: userId || null,
        asunto: asunto.trim(),
        detalle: detalle.trim(),
        prioridad: 'media',
      })
      setMsg(`Ticket creado: ${resp?.data?.ticketCode || 'OK'}`)
      setAsunto('')
      setDetalle('')
    } catch (e) {
      setError(e?.message || 'No se pudo crear el ticket de soporte.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="rounded-lg border border-cyan-200 bg-cyan-50 p-4">
      <h4 className="text-sm font-bold text-cyan-900">Dudas sobre este calculo</h4>
      <p className="mt-1 text-xs text-cyan-800">Abre un ticket con dictamen y version normativa ya vinculados.</p>
      <div className="mt-3 space-y-2">
        <input
          type="text"
          value={asunto}
          onChange={(e) => setAsunto(e.target.value)}
          placeholder="Asunto (ej: Duda sobre movilidad Junio 2026)"
          className="w-full rounded border border-cyan-300 px-3 py-2 text-sm"
        />
        <textarea
          value={detalle}
          onChange={(e) => setDetalle(e.target.value)}
          placeholder="Describe brevemente tu consulta"
          rows={3}
          className="w-full rounded border border-cyan-300 px-3 py-2 text-sm"
        />
        <button
          type="button"
          onClick={handleCreate}
          disabled={loading}
          className="rounded bg-cyan-700 px-3 py-2 text-xs font-semibold text-white hover:bg-cyan-800 disabled:bg-cyan-400"
        >
          {loading ? 'Creando ticket...' : 'Consultar a soporte'}
        </button>
        {msg && <p className="text-xs font-semibold text-emerald-700">{msg}</p>}
        {error && <p className="text-xs font-semibold text-rose-700">{error}</p>}
      </div>
    </div>
  )
}
